import axios from 'axios';
import { mapState } from 'vuex';
import { smartFocus } from '@/utils/uiHelper';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';

// @vue/component
export default {
  name: 'ForgotPassword',
  components: {
    PageHeader,
    Loading,
  },
  data() {
    return {
      email: '',

      passwordReset: false,
      isLoading: false,
      formError: '',
    };
  },
  created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
      const query = Object.assign({}, this.$route.query);
      delete query.email;
      this.$router.replace({ query });
    }
    smartFocus();
  },
  computed: {
    ...mapState({
      loginType: (state) => state.login.loginType,
    }),
    canSubmit() {
      return this.email.trim().length;
    },
    loginLink() {
      let url = '/login';
      if (this.$route.params.productCode) url += `/${this.$route.params.productCode}`;
      return url;
    },
  },
  methods: {
    onSubmit() {
      if (!this.canSubmit || this.isLoading) return;
      this.isLoading = true;
      this.formError = '';

      let url = '/launchpad/v1/forgotpassword.json';
      if (this.loginType !== 'account') url += '?generic=true';

      axios.post(url, { email: this.email.trim() }).then(() => {
        this.passwordReset = true;
        this.isLoading = false;
        smartFocus();
      }).catch(() => {
        this.formError = 'Failed to reset your password, please double-check your email address.';
        this.isLoading = false;
        smartFocus();
      });
    },
    reload() {
      window.location.reload();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/ForgotPassword/ForgotPassword.js